const components = document.querySelectorAll('.block__speakers--v2');
const descriptions = document.querySelectorAll('.speaker__description-container');
const visibleDescriptionSelector = '.speaker__description-container:not(.speaker__description-container--hidden)';
const hiddenClass = 'speaker__description-container--hidden';
const descriptionSelector = '.speaker__description-container';
const closeSelector = '.speaker__close';

const getLeftOffset = (element) => element.getBoundingClientRect().left;

const isMobile = () => window.innerWidth < 768;

const resizeDescription = (component) => {
  const description = component.querySelector(visibleDescriptionSelector);
  if (isMobile()) {
    description.style.transform = '';
  } else {
    const componentOffset = getLeftOffset(component);
    const speakerOffset = getLeftOffset(component.querySelector(visibleDescriptionSelector));

    if (componentOffset !== speakerOffset) {
      const newOffset = speakerOffset - componentOffset;
      // eslint-disable-next-line no-param-reassign
      description.style.transform = `translateX(${-newOffset}px)`;
    }
  }
};

// Check for instances of component on page and run our code for each if any exist.
if (components.length) {
  components.forEach((component) => {
    if (document.querySelector('.block--table-of-contents')) {
      component.classList.add('block__speakers--subnav');
    }
    const componentSpeakers = component.querySelectorAll('.block__speaker.speaker');
    componentSpeakers.forEach((speaker) => {
      const trigger = speaker.querySelector('.speaker__details');
      const closeTrigger = speaker.querySelector(closeSelector);

      // Adds click listener to container around image, name, and title.
      trigger.addEventListener('click', () => {
        const description = speaker.querySelector(descriptionSelector);
        const isActive = !description.className.includes(hiddenClass);

        // Close any bios that are currently displayed.
        descriptions.forEach((desc) => desc.classList.add(hiddenClass));
        component
          .querySelectorAll(closeSelector)
          .forEach((close) => close.classList.add(hiddenClass));

        // Show the bio for the speaker the user clicked.
        if (!isActive) {
          description.classList.remove(hiddenClass);
        }

        closeTrigger.classList.remove(hiddenClass);

        // Calculate offsets before shifting bio location.
        const componentOffset = getLeftOffset(component);
        const speakerOffset = getLeftOffset(speaker);

        // No shifting required if these values match or we're on a mobile device.
        if (componentOffset !== speakerOffset || !isMobile()) {
          const bioOffset = speakerOffset - componentOffset;

          // Shift bio and caret.
          // eslint-disable-next-line no-param-reassign
          speaker
            .querySelector(descriptionSelector)
            .style
            .transform = `translateX(${-bioOffset}px)`;

          // Setting CSS custom property dynamically here.
          speaker
            .querySelector('.speaker__description')
            .style.setProperty('--caret-offset', `${bioOffset + 40}px`);
        }
      });

      // Click listener for close button.
      speaker.querySelector(closeSelector).addEventListener('click', () => {
        speaker.querySelector(descriptionSelector).classList.add(hiddenClass);
      });
    });

    window.addEventListener('resize', () => resizeDescription(component));
  });
}
